'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Link$PvpcontrollerWeb = require("./Link.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");

var alert = Curry._1(Css.style, {
      hd: Css.padding2(Css.px(10), Css.px(15)),
      tl: {
        hd: Css.margin(Css.auto),
        tl: {
          hd: Css.marginTop(Css.px(15)),
          tl: {
            hd: Css.color(Css.hex("abb6c7")),
            tl: {
              hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
              tl: {
                hd: Css.fontSize(Css.px(18)),
                tl: {
                  hd: Css.display("flex"),
                  tl: {
                    hd: Css.justifyContent(Css.spaceBetween),
                    tl: {
                      hd: Css.alignItems(Css.center),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var reviewChanges = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(16)),
      tl: {
        hd: Css.border("zero", "solid", Css.transparent),
        tl: {
          hd: Css.backgroundColor(Css.hex("26282b")),
          tl: {
            hd: Css.padding(Css.px(10)),
            tl: {
              hd: Css.color(Css.hex("abb6c7")),
              tl: {
                hd: Css.borderRadius(Css.px(5)),
                tl: {
                  hd: Css.cursor(Css.pointer),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

function EditModeAlert(Props) {
  return React.createElement("div", {
              className: alert
            }, "Edit mode is currently enabled.", React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("/editmodereview", "", React.createElement("button", {
                          className: reviewChanges
                        }, "Review Changes"), undefined, undefined, undefined, undefined)));
}

function makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var make = EditModeAlert;

exports.makeProps = makeProps;
exports.make = make;
/* alert Not a pure module */
